import { Dialog } from "primereact/dialog";
import CustomeButton from "~/components/Button";
import "./deleteModal.scss";

interface DeleteModalProps {
  visible: boolean;
  isDeleteLoading: boolean;
  deleteHandler: () => void;
  closeModal: () => void;
  header: string;
  description: string;
  icon: any;
}

const DeleteModal = ({
  visible,
  isDeleteLoading,
  deleteHandler,
  closeModal,
  header,
  description,
  icon,
}: DeleteModalProps) => {
  return (
    <Dialog
      visible={visible}
      modal
      className="delete-modal"
      onHide={closeModal}
      style={{ width: "52vw" }}
    >
      <div className="delete-modal-container">
        {/* icon */}
        {icon && <div className="empty__data__view--icon">{icon}</div>}
        <h3 className="header">{header}</h3>
        <p className="content">{description}</p>
      </div>

      <div className="action-container">
        <CustomeButton label="Cancel" onClick={closeModal} />
        <CustomeButton
          label="Yes,Delete"
          variant="remove"
          loading={isDeleteLoading}
          onClick={deleteHandler}
          disabled={isDeleteLoading}
        />
      </div>
    </Dialog>
  );
};

export default DeleteModal;
